/**
 * WhatsApp Desktop Modal Logic
 */
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('desktop-whatsapp-modal');
  if (!modal) return;

  const closeButtons = modal.querySelectorAll('[data-close-modal]');
  const form = document.getElementById('whatsapp-callme-form');
  const feedback = document.getElementById('whatsapp-form-feedback');
  const phoneInput = document.getElementById('whatsapp-client-phone');

  // Business Details
  const businessPhone = '5516996334603';
  const callMeBotApiKey = '4441522'; 

  // Format phone input nicely as the user types (Brazilian format)
  phoneInput.addEventListener('input', (e) => {
    let val = e.target.value.replace(/\D/g, ''); // Remove non-digits
    
    // Limit to 11 digits maximum
    if (val.length > 11) {
      val = val.slice(0, 11);
    }

    // Apply formatting
    if (val.length === 0) {
      e.target.value = '';
    } else if (val.length <= 2) {
      e.target.value = `(${val}`;
    } else if (val.length <= 6) {
      e.target.value = `(${val.slice(0, 2)}) ${val.slice(2)}`;
    } else if (val.length <= 10) {
      e.target.value = `(${val.slice(0, 2)}) ${val.slice(2, 6)}-${val.slice(6)}`;
    } else {
      e.target.value = `(${val.slice(0, 2)}) ${val.slice(2, 7)}-${val.slice(7)}`;
    }
  });

  // Open Modal logic
  const openModal = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  };

  // Close Modal logic
  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    // Reset form
    form.reset();
    feedback.textContent = '';
    feedback.className = 'whatsapp-form-feedback';
  };

  closeButtons.forEach(btn => btn.addEventListener('click', closeModal));

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // Intercept WhatsApp links
  const waLinks = document.querySelectorAll('a[href*="api.whatsapp.com"], a[href*="wa.me"]');
  
  waLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      // Check if desktop/tablet (screen width >= 768px)
      if (window.innerWidth >= 768) {
        e.preventDefault(); // Prevent opening WhatsApp Web
        openModal();
      }
      // If mobile, let it behave normally and open the app
    });
  });

  // Form Submission Logic (CallMeBot)
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      
      const clientNumber = phoneInput.value.replace(/\D/g, '');
      if (clientNumber.length < 10) {
        feedback.textContent = 'Por favor, insira um número válido com DDD.';
        feedback.className = 'whatsapp-form-feedback error';
        return;
      }

      // Prepare CallMeBot text
      const waLink = `https://api.whatsapp.com/send?phone=55${clientNumber}`;
      const message = `🔔 *Novo contato site Supimpa*\nCliente deixou o número: ${clientNumber}\n\n👉 Clique para responder:\n${waLink}`;
      const encodedMessage = encodeURIComponent(message);

      const url = `https://api.callmebot.com/whatsapp.php?phone=${businessPhone}&text=${encodedMessage}&apikey=${callMeBotApiKey}`;

      // Set loading state
      const submitBtn = document.getElementById('whatsapp-submit-btn');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Enviando...';
      submitBtn.disabled = true;

      // Make the request using no-cors because CallMeBot API doesn't send CORS headers
      // Since it's no-cors, we can't read the response properly, but it sends the message.
      fetch(url, { mode: 'no-cors' })
        .then(() => {
          feedback.textContent = 'Sucesso! Nós enviaremos uma mensagem para você em breve.';
          feedback.className = 'whatsapp-form-feedback success';
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          
          // Auto close after 3 seconds
          setTimeout(closeModal, 3000);
        })
        .catch(err => {
          console.error('CallMeBot Error:', err);
          feedback.textContent = 'Ocorreu um erro. Por favor, tente a Opção 1 (QR Code).';
          feedback.className = 'whatsapp-form-feedback error';
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        });
    });
  }
});
